import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("textBlock", component(opts));
  editor.BlockManager.add("textBlock", block(opts));
};